import React, { Component } from 'react';
import ExtractArticleQuery  from '../extractArticleQuery';
import urlHandler           from '../../../utils/urlHandler';
import perms                from '../../../utils/permissions';
import examples             from '../../../utils/examples';
import HttpRunner           from '../query';

class DocV1ExtractArticle extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_EXTRACT_ARTICLE)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <h3 className="heading-1">Extract Article</h3>
                <code className="api-definition">
                    <span className="get-badge">GET</span>&nbsp;{urlHandler.API_ENDPOINT_V1_EXTRACT_ARTICLE}?{'{'}query parameters{'}'}
                </code>
                <div className="description">
                    The extract-article endpoint extracts text from a given news web address or URL. It returns not only the extracted text, but 
                    other information if it can be detected from the article, including: <br/>
                    <div className="bullet-list">
                        <ul className="toc-level list-wrapper">
                            <li className="list-item">List of authors</li>
                            <li className="list-item">An embedded image</li>
                            <li className="list-item">List of keywords</li>
                            <li className="list-item">Published date</li>
                            <li className="list-item">Article summary</li>
                            <li className="list-item">Article title</li>
                            <li className="list-item">List of embedded videos</li>
                        </ul>
                    </div>
                </div>

                <h4 className="heading-2" id="extractarticlev1_request">Request</h4>

                <div className="heading-3">Query Parameters</div>
                <div className="description">
                    The following query parameters are supported for the extract-article request.
                </div>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">url</td>
                        <td className="meaning">Valid web URL for a news article.
                        </td>
                        <td className="type">String</td>
                        <td className="type">Required</td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-2" id="extractarticlev1_response">Response</h4>
                <div className="description">
                    The extract-article endpoint returns a JSON response.
                </div>

                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">authors</td>
                        <td className="meaning">List of authors detected from the article.
                        </td>
                        <td className="type">[String]</td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">image</td>
                        <td className="meaning">An image link associated with the article.
                        </td>
                        <td className="type">String</td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">keywords</td>
                        <td className="meaning">List of keywords detected from the article.
                        </td>
                        <td className="type">[String]</td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">published</td>
                        <td className="meaning">The published date of the article in format <i>YYYY-MM-DD hh:mm:ss</i>.
                        </td>
                        <td className="type">String</td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">summary</td>
                        <td className="meaning">Textual summary of the article.
                        </td>
                        <td className="type">String</td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">title</td>
                        <td className="meaning">Title of the article.
                        </td>
                        <td className="type">String</td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">videos</td>
                        <td className="meaning">List of videos detected in the article.
                        </td>
                        <td className="type">[String]</td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">body</td>
                        <td className="meaning">The extracted text of the article.
                        </td>
                        <td className="type">String</td>
                        <td className="type">Optional</td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-2">Example</h4>
                <div className="example-content host">
                    <pre>
                        GET {urlHandler.API_ENDPOINT_V1_EXTRACT_ARTICLE}?url=https://www.foxnews.com/health/black-history-month-dr-alexander-thomas-augusta-first-black-surgeon-civil-war<br/>
                        Authorization: Bearer [YOUR-API-KEY]<br/>
                        <br/>
                    </pre>
                </div>
                <HttpRunner query="extract-article" 
                        stated={`url=${encodeURIComponent('https://www.foxnews.com/health/black-history-month-dr-alexander-thomas-augusta-first-black-surgeon-civil-war')}`}
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_V1_EXTRACT_ARTICLE) : null}
                />
                {this.state.dynamicSample &&
                    <div>
                        <br/>
                        <h4 className="heading-3">Try It Yourself</h4>
                        <ExtractArticleQuery/>
                    </div>
                }
            </div>
        );
    }
}

export default DocV1ExtractArticle;